export default __webpack_public_path__ + "static/media/sport.35d9863d.jpg";